import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { Award, Shield, TrendingUp } from 'lucide-react';
export const Certification = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1
  });
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };
  return <section id="certification" className="py-20 bg-white" data-id="element-302" data-mp="71h6v4uf2ciq">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-303" data-mp="23flgd9iq143">
        <motion.div ref={ref} initial="hidden" animate={inView ? 'visible' : 'hidden'} transition={{
        duration: 0.8
      }} variants={itemVariants} className="text-center mb-16" data-id="element-304" data-mp="1iigvnqhk2980">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-305" data-mp="cq3leawi23jk">
            Ukweli Certified™ Program
          </h2>
          <div className="w-20 h-1 bg-blue-600 mx-auto mb-6" data-id="element-306" data-mp="lrbac2d4ls0z"></div>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-307" data-mp="lruwjv9t72kt">
            The world's first three-tier evidence seal for supplements and
            functional products—empowering informed decisions based on
            scientific merit.
          </p>
        </motion.div>
        <motion.div ref={ref} initial="hidden" animate={inView ? 'visible' : 'hidden'} variants={containerVariants} className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-308" data-mp="3u7mye9zkl459">
          <motion.div variants={itemVariants} className="relative bg-white border-2 border-gray-200 rounded-lg p-8 hover:border-blue-500 transition-colors duration-300" data-id="element-309" data-mp="7td8txjwlq2w">
            <div className="absolute top-0 right-0 mt-4 mr-4" data-id="element-310" data-mp="3be0ugo2uucjq">
              <Shield className="h-12 w-12 text-blue-100" data-id="element-311" data-mp="33ecyzlsh65o1" />
            </div>
            <div className="mb-4" data-id="element-312" data-mp="2zevtwtgynaje">
              <span className="inline-block py-1 px-3 rounded-full text-xs font-semibold bg-blue-100 text-blue-800" data-id="element-313" data-mp="2zdu57m70upj7">
                Tier 1
              </span>
            </div>
            <h3 className="text-xl font-bold mb-3 text-gray-900" data-id="element-314" data-mp="387fnhfieaoxd">
              Basic Verification
            </h3>
            <ul className="space-y-2 text-gray-700" data-id="element-315" data-mp="2khbqvs3mjpfv">
              <li className="flex items-start" data-id="element-316" data-mp="2gfq8xsc8gkyt">
                <span className="text-green-500 mr-2" data-id="element-317" data-mp="2gh1bjotxzmoc">✓</span>
                <span data-id="element-318" data-mp="2uf9eqehknk7y">Ingredient authenticity verified</span>
              </li>
              <li className="flex items-start" data-id="element-319" data-mp="2pg684ply15xv">
                <span className="text-green-500 mr-2" data-id="element-320" data-mp="2peborfqbllvw">✓</span>
                <span data-id="element-321" data-mp="9o8wi2rc4soo">Contaminant testing completed</span>
              </li>
              <li className="flex items-start" data-id="element-322" data-mp="4pnwa3c32908">
                <span className="text-green-500 mr-2" data-id="element-323" data-mp="4ow2my21qlcl">✓</span>
                <span data-id="element-324" data-mp="1mnk8bbp8i3va">Manufacturing standards assessment</span>
              </li>
            </ul>
          </motion.div>
          <motion.div variants={itemVariants} className="relative bg-white border-2 border-gray-200 rounded-lg p-8 hover:border-blue-500 transition-colors duration-300" data-id="element-325" data-mp="1rmne4yd1ge4b">
            <div className="absolute top-0 right-0 mt-4 mr-4" data-id="element-326" data-mp="1imqk0h7vqn1v">
              <Award className="h-12 w-12 text-blue-200" data-id="element-327" data-mp="26b9xdb5sdq0t" />
            </div>
            <div className="mb-4" data-id="element-328" data-mp="26de5k5apxb6w">
              <span className="inline-block py-1 px-3 rounded-full text-xs font-semibold bg-blue-100 text-blue-800" data-id="element-329" data-mp="2adeljudgtug2">
                Tier 2
              </span>
            </div>
            <h3 className="text-xl font-bold mb-3 text-gray-900" data-id="element-330" data-mp="21kl3xqajqiz1">
              Efficacy Evidence
            </h3>
            <ul className="space-y-2 text-gray-700" data-id="element-331" data-mp="2pafbptg0dhcf">
              <li className="flex items-start" data-id="element-332" data-mp="2p8uiq89ce6go">
                <span className="text-green-500 mr-2" data-id="element-333" data-mp="2u1dxh8jrn7n2">✓</span>
                <span data-id="element-334" data-mp="2u2yst0dwmulz">All Tier 1 verifications</span>
              </li>
              <li className="flex items-start" data-id="element-335" data-mp="15fuikpwezidg">
                <span className="text-green-500 mr-2" data-id="element-336" data-mp="10fydsofw7mwu">✓</span>
                <span data-id="element-337" data-mp="10en6wfr5hz1i">In-vitro efficacy testing</span>
              </li>
              <li className="flex items-start" data-id="element-338" data-mp="wfecr9s77z5f">
                <span className="text-green-500 mr-2" data-id="element-339" data-mp="wg7nelua38su">✓</span>
                <span data-id="element-340" data-mp="rgl9092prmig">Bioavailability assessment</span>
              </li>
              <li className="flex items-start" data-id="element-341" data-mp="1o5smqux3crbt">
                <span className="text-green-500 mr-2" data-id="element-342" data-mp="1o7n8gbg6sngy">✓</span>
                <span data-id="element-343" data-mp="1k50dw2s4sog2">Mechanism validation</span>
              </li>
            </ul>
          </motion.div>
          <motion.div variants={itemVariants} className="relative bg-white border-2 border-gray-200 rounded-lg p-8 hover:border-blue-500 transition-colors duration-300" data-id="element-344" data-mp="1fbxsihxiclay">
            <div className="absolute top-0 right-0 mt-4 mr-4" data-id="element-345" data-mp="27ubgzqwyeuxd">
              <TrendingUp className="h-12 w-12 text-blue-300" data-id="element-346" data-mp="2329xpl1dc3xu" />
            </div>
            <div className="mb-4" data-id="element-347" data-mp="2ady30hvx3wzw">
              <span className="inline-block py-1 px-3 rounded-full text-xs font-semibold bg-blue-100 text-blue-800" data-id="element-348" data-mp="2aezq5kq7k9xz">
                Tier 3
              </span>
            </div>
            <h3 className="text-xl font-bold mb-3 text-gray-900" data-id="element-349" data-mp="2kbm9g52vysxw">
              Clinical Validation
            </h3>
            <ul className="space-y-2 text-gray-700" data-id="element-350" data-mp="2odzbaieii6pe">
              <li className="flex items-start" data-id="element-351" data-mp="2obea7vm1fusp">
                <span className="text-green-500 mr-2" data-id="element-352" data-mp="2tbsk7j779etd">✓</span>
                <span data-id="element-353" data-mp="2ybx0p983y9jl">All Tier 1 & 2 verifications</span>
              </li>
              <li className="flex items-start" data-id="element-354" data-mp="2y9u240sw3839">
                <span className="text-green-500 mr-2" data-id="element-355" data-mp="332ddqs80nt5f">✓</span>
                <span data-id="element-356" data-mp="334zmgv6n8ep8">Human clinical trial data</span>
              </li>
              <li className="flex items-start" data-id="element-357" data-mp="3816qgifhbg4j">
                <span className="text-green-500 mr-2" data-id="element-358" data-mp="3c3l9b2j5efvt">✓</span>
                <span data-id="element-359" data-mp="3c18l47msr9ab">Long-term safety monitoring</span>
              </li>
              <li className="flex items-start" data-id="element-360" data-mp="3h36cjp5cpaec">
                <span className="text-green-500 mr-2" data-id="element-361" data-mp="1h056kpkwp84l">✓</span>
                <span data-id="element-362" data-mp="1h0oq2aq7g4kq">Peer-reviewed research publication</span>
              </li>
            </ul>
          </motion.div>
        </motion.div>
        <motion.div variants={itemVariants} initial="hidden" animate={inView ? 'visible' : 'hidden'} transition={{
        delay: 0.6
      }} className="mt-12 text-center" data-id="element-363" data-mp="1qpyi5ql1tn8u">
          <a href="#contact" className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors duration-300" data-id="element-364" data-mp="20mtcdxaah1hb">
            Apply for Certification
          </a>
        </motion.div>
      </div>
    </section>;
};